<template>
  <div class="radio-type-wrapper">
    <div v-if="hasIcon" :class="['radio-type-hasIcon', { 'is-detail': isDetail }, { 'is-two': !isDetail && quesData.memberAnswerList.length === 2 }]">
      <template v-for="(item, key) in quesData.memberAnswerList">
        <div v-if="isDetail && item.memberOptionSelected" :key="key" class="radio-item-detail">
          <!-- <img v-if="item.optionIconUrl" :src="item.optionIconUrl" /> -->
          <div class="label">{{ item.optionTitle }}</div>
        </div>
        <div
          v-else-if="!isDetail"
           :key="key"
          :class="['radio-item', { 'is-active': quesData.value === item.answerId }]"
          @click.stop="chooseItem(item)">
          <img :src="item.optionIconUrl" />
          <div class="label">{{ item.optionTitle }}</div>
        </div>
      </template>
    </div>
    <div v-else class="radio-type">
      <van-radio-group v-model="quesData.value">
        <template v-for="(item, key) in quesData.memberAnswerList">
          <van-radio v-if="!isDetail || (isDetail && item.memberOptionSelected)" :key="key" :name="item.answerId" icon-size="18px" class="radio-item" @click.stop="onChange(item.answerId)">
            <template #icon="props">
              <img v-if="props.checked" class="img-icon" src="../../../../assets/crf/checked.png" />
              <img v-else class="img-icon" src="../../../../assets/crf/unchecked.svg" />
            </template>
            {{ item.optionTitle }}
          </van-radio>
        </template>
      </van-radio-group>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  name: 'RadioType',
  props: {
    questionData: {
      type: Object,
      default() {}
    },
    isDetail: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      quesData: this.questionData,
    };
  },
  created() {
    if (this.isDetail) {
      this.quesData.value = _.find(this.questionData.memberAnswerList, { memberOptionSelected: 1 })?.answerId || null;
    }
  },
  computed: {
    hasIcon() {
      return _.filter(this.quesData.memberAnswerList, item => !!item.optionIconUrl)?.length > 0;
    }
  },
  methods: {
    onChange(val) {
      const memberAnswerList = this.questionData.memberAnswerList?.map(item => {
        return {
          ...item, 
          memberOptionSelected: item.answerId === val ? 1 : 0
        }
      });
      this.$set(this.quesData, 'memberAnswerList', memberAnswerList);
      this.$emit('onChange');
    },
    chooseItem(item) {
      this.$set(this.quesData, 'value', item.answerId)
      this.onChange(item.answerId);
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-type-wrapper {
  margin-top: 24px;
  :deep(.van-radio__icon--checked+.van-radio__label) {
    font-weight: 500;
  }
  .radio-type-hasIcon {
    display: flex;
    flex-wrap: wrap;
    gap: 26px;
    &.is-detail {
      justify-content: flex-start;
      margin-top: 16px;
    }
    &.is-two {
      justify-content: center;
      gap: 130px;
    }
    .radio-item-detail {
      background: #FFEEEB;
      border-radius: 38px;
      display: flex;
      align-items: center;
      padding: 10px 40px;
      font-weight: 500;
      font-size: 28px;
      img {
        width: 48px;
        height: 48px;
        margin-right: 22px;
      }
    }
    .radio-item {
      width: 210px;
      border: 2px solid #E5E5E5;
      border-radius: 16px;
      overflow: hidden;
      background: #F8F8F8;
      text-align: center;
      box-sizing: border-box;
      flex: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-content: space-between;
      &.is-active {
        border: 2px solid #FF583E;
        background: #FFEEEB;
      }
      img {
        width: 100%;
      }
      .label {
        font-weight: 500;
        font-size: 28px;
        color: #3A3B3C;
        margin: 16px;
        word-wrap: break-word;
      }
    }
  }
  .radio-type {
    .radio-item {
      margin-top: 36px;
      align-items: flex-start;
      &:nth-child(1) {
        margin-top: 0;
      }
    }
    .img-icon {
      margin-top: 1px;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
